(function () {
  if (typeof window === 'undefined') return;

  function init() {
    const root = document.querySelector('[data-pdp-notify-me]');
    if (!root) return;

    const form = root.querySelector('[data-pdp-notify-form]');
    const input = root.querySelector('[data-pdp-notify-input]');
    const submit = root.querySelector('[data-pdp-notify-submit]');
    const status = root.querySelector('[data-pdp-notify-status]');
    const label = root.querySelector('[data-pdp-notify-label]');
    if (!form || !input || !submit || !status) return;

    const companyId = root.dataset.companyId;
    const variantId = root.dataset.variantId;
    const productId = root.dataset.productId;

    function setStatus(message, state) {
      status.textContent = message;
      status.dataset.state = state || '';
    }

    function setBusy(busy) {
      submit.disabled = busy;
      submit.dataset.busy = busy ? 'true' : 'false';
      if (label) {
        label.textContent = busy
          ? root.dataset.labelLoading || 'Sender...'
          : (root.dataset.labelDefault || label.dataset.original || label.textContent);
      }
    }

    if (label && !label.dataset.original) {
      label.dataset.original = label.textContent.trim();
    }

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const email = (input.value || '').trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setStatus(root.dataset.copyInvalid || 'Indtast en gyldig e-mail', 'error');
        input.focus();
        return;
      }

      setBusy(true);
      setStatus('', '');

      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + variantId
              }
            }
          }
        }
      };

      try {
        const res = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-10-15',
            'accept': 'application/vnd.api+json'
          },
          body: JSON.stringify(payload)
        });

        if (!res.ok && res.status !== 202) {
          const errText = await res.text();
          throw new Error('subscribe failed: ' + res.status + ' ' + errText.slice(0, 200));
        }

        form.hidden = true;
        setStatus(root.dataset.copySuccess || 'Tak - vi sender besked når den er tilbage på lager.', 'success');
      } catch (err) {
        console.error('[pdp-notify-me]', err);
        setStatus(root.dataset.copyError || 'Noget gik galt. Prøv igen om lidt.', 'error');
        setBusy(false);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('variant:change', function () {
    setTimeout(init, 50);
  });
})();
